import SmartApplyConfirmationModal from "./SmartApplyConfirmationModal";

export default SmartApplyConfirmationModal;
